import React from 'react';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { Input } from '../../input/input.js';
function formatDate(value) {
    return ModelService.format('date', value);
}
function joinDates(startDate, endDate) {
    if (endDate) {
        return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    }
    return formatDate(startDate);
}
function DateFieldInterval(props) {
    const { enabled, endDate, externalAction, onClick, placeholder, readOnly, startDate, valid, sensitiveData } = props;
    const value = joinDates(startDate, endDate);
    return (React.createElement("div", { className: "c-date-field__container" },
        React.createElement("div", { className: "c-date-field--interval", onClick: onClick },
            React.createElement(Input, { enabled: enabled, externalAction: externalAction, onFocus: onClick, placeholder: placeholder, readOnly: readOnly, sensitiveData: sensitiveData, valid: valid, value: value }))));
}
export { DateFieldInterval, };
//# sourceMappingURL=date-field-interval.js.map